
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import Listbox from 'primevue/listbox'
import lovsManagementProfileAttributesListDescriptor from './LovsManagementProfileAttributesListDescriptor.json'

export default defineComponent({
    name: 'lovs-management-info-dialog',
    components: { Dialog, Listbox },
    emits: ['close', 'selected'],
    props: { visible: { type: Boolean }, profileAttributes: { type: Array } },
    data() {
        return {
            lovsManagementProfileAttributesListDescriptor
        }
    },
    created() {},
    methods: {}
})
